import {
  COMPLETED_CORRECTION,
  FOCUS_PLANNING,
  IN_PLANNING,
  SET_HISTORY,
  SET_HISTORY_FILTER,
  SET_PLANNINGS,
  SET_HISTORY_LOADING,
  SET_PROCESS_HISTORY,
  SET_TOTAL_PAGES,
  SET_CURRENT_PAGE,
  SET_TOTAL_PLANNING_COUNT,
  SET_PROCESS_PAGE_CACHE,
  SET_PLANNING_STATUS_CODE
} from '../actions/types';
const MAX_RESULTS = 100;

const initialState = {
  corrected: null,
  inPlanning: null,
  plannings: {},
  planningFocus: null,
  loading: true,
  processHistory: [],
  totalPages: 0,
  currentPage: 1,
  totalPlanningsCount: 0,
  pageCache: {},
  planningStatusCode: undefined,
  history: {
    page: 0,
    num_results: 0,
    total_pages: 0,
    results_per_page: MAX_RESULTS,
    process: [],
    filters: [{
      id:'state',
      op:'='
    }]
  }
};

export default function planningReducer (state = initialState, { type, data }) {
  switch (type) {
  case SET_PROCESS_HISTORY:
    return {
      ...state,
      processHistory: data
    };
  case SET_HISTORY:
    return {
      ...state,
      history: {
        ...state.history,
        ...data
      }
    };
  case SET_HISTORY_FILTER:
    return {
      ...state,
      history: {
        ...state.history,
        filters: data
      }
    };
  case COMPLETED_CORRECTION:
    return ({
      ...state,
      corrected: data
    });

  case SET_PLANNINGS:
    return {
      ...state,
      plannings: data
    };
  case FOCUS_PLANNING:
    return {
      ...state,
      planningFocus: data
    };
  case IN_PLANNING:
    return ({
      ...state,
      inPlanning: data
    });
  case SET_HISTORY_LOADING:
    return ({
      ...state,
      loading: data
    });
  case SET_CURRENT_PAGE:
    return {
      ...state,
      currentPage: data
    };
  
  case SET_TOTAL_PAGES:
    return {
      ...state,
      totalPages: data
    };

  case SET_TOTAL_PLANNING_COUNT:
    return {
      ...state,
      totalPlanningsCount: data
    };  
  case SET_PROCESS_PAGE_CACHE:
    return {
      ...state,
      pageCache: {
        ...state.pageCache,
        [data.page]: data.results,
      },
    };
  case SET_PLANNING_STATUS_CODE:
    return {
      ...state,
      planningStatusCode: data
    };         
  default:
    return state;
  }
}
